// Optically center Font Awesome glyphs inside the icon-card circles.
// Each FA glyph sits at a different height within its em box, so flex
// centering the box leaves short/wide icons riding high. Measure each
// glyph's actual ink bounds and nudge it so the ink is centered.

const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');

function centerIcon(icon, attempt = 0) {
  const style = getComputedStyle(icon, '::before');
  const glyph = style.content.replace(/["']/g, '');

  // kit CSS not injected yet, try again shortly
  if (!glyph || glyph === 'none') {
    if (attempt < 20) setTimeout(() => centerIcon(icon, attempt + 1), 150);
    return;
  }

  const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;

  document.fonts.load(font, glyph).then(() => {
    ctx.font = font;
    const m = ctx.measureText(glyph);
    const inkMid = (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2;
    const boxMid = (m.fontBoundingBoxAscent - m.fontBoundingBoxDescent) / 2;
    icon.style.transform = `translateY(${inkMid - boxMid}px)`;
  });
}

window.addEventListener('load', function () {
  document.querySelectorAll('.card-icon .icon-content i').forEach(icon => centerIcon(icon));
});
